<div class="ui-g">
  <div class="ui-g-4 padding20">
    <!-- TODO: traduzioni -->


    <div class="ui-g-12 c3_element_title">{{'campaign.action_type' | translate }}<span class="required">*</span></div>

    <br />
    <div class="c3_actionTypeContainer">
      <div *ngFor="let at of actionTypesList;let i=index;" class="c3_actionType"
        [ngStyle]="{'width': actionType.width + '%' }"
        [ngClass]="{'actionTypeActive': at.code == actionType.currentCode }">{{at.name}}</div>
      <div class="clear_fix"></div>
    </div>
    <div class="new_or_exist"
      *ngIf="show.new_or_exists && !readOnly == true && ui_mode == srvCampaign3.ui_modes.CREATE">
      <button data-testid="couponExistsButton" pButton size="large" severity="info" (click)="onClickExists()"
        icon="fa fa-arrow-right" iconPos="left" type="button" id="couponExistsButton"
        [label]="'campaign.create_from_existing' | translate"></button>
      <button data-testid="couponNewButton" pButton size="large" severity="info" (click)="onClickNew()"
        icon="fa fa-plus" iconPos="left" type="button" id="couponNewButton"
        [disabled]="readOnly == true || ui_mode == srvCampaign3.ui_modes.EDIT"   [label]="'campaign.create_from_new' | translate"></button>
      <div class="clear_fix"></div>
    </div>
  </div>
  <div class="ui-g ui-g-8 padding20">

    <div id="infoBaseCouponForm" [ngClass]="{'notPermitted': readOnly == true}">

      <div class="ui-g-12" *ngIf="show.tipoCoupon">
        <div class="ui-g-12">
          <app-form-fields #coupon_type data-testid="coupon_type" (fieldModelChange)="onChangeCouponType($event)"
          [label]="'campaign.coupon_type' | translate" 
            [required]="true" [disabled]="readOnly" [(fieldModel)]="fieldModel.coupon_type" [type]="'dropdown'"
            [options]="comboCouponType" [optionLabel]="'description'"
            [placeholder]="'campaign.select_coupon_type' | translate"></app-form-fields>

        </div>
      </div>
      <div class="ui-g-12" *ngIf="formSchema && ready.form">
        <div class="ui-g-6">
          <app-form-fields #advantage_type data-testid="advantage_type" [fieldSchema]="formSchema.form.advantage_type"
            [(fieldModel)]="fieldModel.advantage_type" [readOnly]="readOnly" [options]="comboAdvantageType"
            [optionLabel]="'description'" [placeholder]="'campaign.select_advantage_type' | translate"></app-form-fields>

        </div>
        <div class="ui-g-6">
          <app-form-fields #value_coupon data-testid="value_coupon" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.valore_coupon" [(fieldModel)]="fieldModel.value_coupon"></app-form-fields>
        </div>
      </div>
      <div class="ui-g-12" *ngIf="formSchema && ready.form">
        <div class="ui-g-6">
          <app-form-fields #name data-testid="name" [fieldSchema]="formSchema.form.name" [readOnly]="readOnly"
            [(fieldModel)]="fieldModel.name" [name]="'name'"></app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #int_code data-testid="int_code" [readOnly]="readOnly" [(fieldModel)]="fieldModel.int_code"
            [fieldSchema]="formSchema.form.int_code"></app-form-fields>
        </div>
      </div>
      <div class="ui-g-12" *ngIf="formSchema && ready.form">
        <div class="ui-g-6">
          <app-form-fields #public_description data-testid="public_description" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.public_description"
            [(fieldModel)]="fieldModel.public_description"></app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #int_note data-testid="int_note" [(fieldModel)]="fieldModel.int_note" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.int_note"></app-form-fields>
        </div>
      </div>
      <br />
    </div>

  </div>
</div>


<p-dialog *ngIf="show.popup_fromCoupon" [width]="1500" [height]="800" [(visible)]="show.popup_fromCoupon"
  [responsive]="true" [header]="existingModalTitle" showEffect="fade" [modal]="true" (onHide)="onDialogHide()">
  <!--
  <app-create-coupon-from-existing #fromExisting data-testid="fromExisting" (messageInstanceSelected)="onMessageInstanceSelected($event)" [dateFormat]="dateFormat" [campaignInfoTo]="campaignInfo" [comboGiornoSettimanaInizioFruizione]="comboGiornoSettimanaInizioFruizione" [comboGiornoSettimanaFineFruizione]="comboGiornoSettimanaFineFruizione" [comboInizioFruizione]="comboInizioFruizione" [comboFineFruizione]="comboFineFruizione"></app-create-coupon-from-existing>
-->

  <app-create-coupon-from-existing #fromExisting data-testid="fromExisting"
    (messageInstanceSelected)="onMessageInstanceSelected($event)" [dateFormat]="dateFormat"
    [campaignInfoTo]="campaignInfo" [comboInizioFruizione]="comboInizioFruizione"
    [comboFineFruizione]="comboFineFruizione"></app-create-coupon-from-existing>

  <!-- Bottoni Annulla e Aggiungi -->
  <div class="ui-dialog-footer buttonsContainer" *ngIf="show.fromExistingButtons">
    <button data-testid="cancel" pButton type="button" (click)="onClickCancelFromExisting()"
      class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <button data-testid="create" pButton type="button" (click)="onClickCreateFromExisting()"
      class="k-generic-btn footer-btn" label="{{'common.create' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>



  <!--<ng-content></ng-content>-->
</p-dialog>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-info-base/campaign-3-info-base.component.html